import isObject from '@/helpers/isObject';

export function target() {
  return (
    ['BannerWithMenu', 'Header', 'NewFooter'].includes(this.module) &&
    isObject(this.data.menuLinks) &&
    !!this.data.menuLinks.value
  );
}

export function migrate() {
  const { value, ...menuLinks } = this.data.menuLinks;
  this.data.menuLinks = { globalReference: value, ...menuLinks };
}
